import { FC, useCallback, useState } from "react";
import { Flex } from "@otrium/core";
import { Trans } from "@lingui/macro";
import { Heart } from "src/icons/Heart";
import { HeartActive } from "src/icons/HeartActive";
import { HeartFull } from "src/icons/HeartFull";
import { LoadingSpinner } from "src/atoms/LoadingSpinner";
import { StyledAnimatedSvg } from "./FollowBrand.styled";

const HeartAnimated = ({ hover }: { hover: boolean }) => {
  return (
    <StyledAnimatedSvg hover={hover}>
      <Heart width="22" height="22" strokeWidth={"2"} />
      <HeartActive width="22" height="22" strokeWidth={"2"} />
    </StyledAnimatedSvg>
  );
};

interface Props {
  following: boolean | undefined;
  onClick: () => void;
  loading: boolean;
}
const FollowBrandButton: FC<Props> = ({
  following,
  onClick,
  loading,
  ...rest
}): JSX.Element | null => {
  const [hover, setHover] = useState(false);
  const handleMouseEnter = useCallback(() => setHover(true), []);
  const handleMouseLeave = useCallback(() => setHover(false), []);
  if (following === undefined) {
    return null;
  }
  return (
    <Flex
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={onClick}
      as="button"
      px={1}
      justifyContent="center"
      alignItems="center"
      color="White"
      sx={{
        background: "transparent",
        border: "none",
        cursor: "pointer",
        position: "relative",
      }}
      {...rest}
    >
      {loading ? (
        <StyledAnimatedSvg>
          <LoadingSpinner height="20px" width="20px" stroke="white" />
        </StyledAnimatedSvg>
      ) : (
        <>
          {following ? (
            <StyledAnimatedSvg>
              <HeartFull width="22" height="22" strokeWidth={"2"} />
            </StyledAnimatedSvg>
          ) : (
            <HeartAnimated hover={hover} />
          )}
        </>
      )}
      {following ? <Trans>Following</Trans> : <Trans>Follow</Trans>}
    </Flex>
  );
};

export default FollowBrandButton;
